import {
	UndefinedInitialDataOptions,
	queryOptions
} from '@tanstack/react-query'

import { getServerLikesActive } from '@wwt/core/admin'
import { SetsResponseDto } from '@wwt/entities/api/search-response'

import { setKeys } from '../config/setKeys.ts'
import { setsQuery } from '../query/setsQuery.ts'
import { SetMutationUtils } from '../utils/setMutationUtils.ts'

export const setsOptions = (
	otherParams: Omit<
		UndefinedInitialDataOptions<SetsResponseDto>,
		'queryKey' | 'queryFn'
	> = {}
) => {
	return queryOptions<SetsResponseDto>({
		queryKey: setKeys.all(),
		queryFn: ({ signal }) => setsQuery(signal),
		placeholderData: { sets: [] },
		initialData: () => {
			if (!getServerLikesActive()) {
				return { sets: [SetMutationUtils.generateSet({ title: 'Default' })] }
			}

			return { sets: [] }
		},
		initialDataUpdatedAt: 0,

		...otherParams
	})
}
